import { CERTIFICATES_DATA } from "../../constant/CompanyData";
import CertSeal from "../DataCenters/CertSeal";

const isoCode = (title) => title.match(/\d{4,5}/)?.[0] ?? "";

const CertTrustStrip = () => {
  return (
    <section className="border-y border-slate-200 bg-slate-50 px-6 py-14">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-8 sm:flex-row sm:justify-between">
        <div className="text-center sm:text-left">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            Certified &amp; compliant
          </p>
          <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-600">
            Every QuantaRock facility operates under the same information
            security and quality management standards.
          </p>
        </div>

        <div className="w-full overflow-x-auto sm:w-auto">
          {/* w-max + mx-auto centres the seals when they fit and degrades to a
              plain left-aligned scroll when they don't */}
          <div className="mx-auto flex w-max items-center gap-5 px-1 sm:mx-0">
            {CERTIFICATES_DATA.map((cert) => (
              <a
                key={cert.id}
                href={cert.file}
                target="_blank"
                rel="noopener noreferrer"
                title={cert.title}
                className="flex flex-shrink-0 flex-col items-center gap-2 transition hover:-translate-y-0.5"
              >
                <CertSeal code={isoCode(cert.title)} size={112} />
                <span className="whitespace-nowrap text-xs font-semibold text-[var(--website-primary-color)]">
                  {cert.title}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertTrustStrip;
